export { ReportDetails } from './ReportDetails';
